import { useMount } from "ahooks";
import React, { useState } from "react";
import { FileIcon } from "./Icon";
import { isImage, getSafeUrl } from "./utils";
import { api } from "@/redux/api";

export const ImageView = ({ item, isSelected }) => {
    const [imageUrl, setImageUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    useMount(async () => {
        // 判断是否为图片格式
        if (item?.image && isImage(item.image)) {
            setIsLoading(true);
            try {
                // 请求具有权限的图片链接
                const response = await api.generate_url(getSafeUrl(item.image), true);
                const url = response.data.url;
                setImageUrl(url);
            } catch (error) {
                console.error('Failed to generate image URL:', error);
                setHasError(true);
            } finally {
                setIsLoading(false);
            }
        }
    });

    // 如果是图片格式且已经获取到URL，显示图片
    if (item?.image && isImage(item.image) && imageUrl && !hasError) {
        return (
            <div style={{
                width: '80px',
                height: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <img
                    src={imageUrl}
                    alt={item.name || 'image'}
                    style={{
                        maxWidth: '80px',
                        maxHeight: '80px',
                        borderRadius: '6px',
                        filter: isSelected ? 'invert(1)' : 'none'
                    }}
                    onError={() => setHasError(true)}
                />
            </div>
        );
    }

    // 默认显示FileIcon（包括非图片格式、加载中、加载失败的情况）
    return (
        <FileIcon
            ischecked={isSelected}
            size={52}
            isFolder={item.isFolder}
            title={item.title || item.name}
        />
    );
};
